module.exports = __webpack_public_path__ + "static/media/transport-infrastructure.ba64f7ca.png";